export const ACTIVATION_ORDER_FULFILLMENT_STATUS_LABELS = {
    false: 'Awaiting Fulfillment',
    true: 'Fulfilled - Shipping Status Unknown'
};
